import React, {Fragment} from 'react'

const TabPanel = ({ selectedIndex, index, children }) => {
  return (
    <Fragment>{(index === selectedIndex) && children}</Fragment>
  )
}

export default TabPanel
